import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';

const ListPage = lazy(() => import('./pages/orders-list-page').then((m) => ({ default: m.OrdersListPage })));
const DetailPage = lazy(() => import('./pages/order-detail-page').then((m) => ({ default: m.OrderDetailPage })));

const Fallback = () => (
  <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} aria-hidden className="skeleton h-10 w-full" />
    ))}
  </div>
);

/** Montado em `pedidos/*`. */
export function OrdersRoutes() {
  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route index element={<ListPage />} />
        <Route path=":id" element={<DetailPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </Suspense>
  );
}
